var DropDownOptions = require("components/utility/DropDownOptions");
var Modal = require("components/utility/AltModal");
var LoadingButton = require("components/utility/LoadingButton");
var CurrentUser = require("lib/account/CurrentUser");

require("org/roster/add_new_class_modal.scss");

class AddNewClassModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			classRows: 4, studentLists: props.studentLists, loading: false
		};
	}

	submitClass(e) {
		$wr.nope(e)
		var names = [];
		var teacherEmails = [];
		var grade_levels = [];
		for (var i = 0; i < this.state.classRows; i++) {
			var nameChecked = this.refs["name" + i].value.trim()
			if (nameChecked.length > 0) {
				names.push(nameChecked)

				if (this.refs["teacher_email" + i]) {
					teacherEmails.push((this.refs["teacher_email" + i]).value)
				} else {
					teacherEmails.push("");
				}
				grade_levels.push((this.refs["grade_level" + i]).value)
			}
		}
		var studentLists = { name: names, teacher_email: teacherEmails, grade_level: grade_levels };

		if (names.length > 0) {
			if (!this.state.loading) {
				this.setState({ loading: true });

				var params = {
					student_lists: studentLists, 
					embed: "student_list.students,student_list.primary_admin,admin.email,student_list.passphrase,student_list.prefs"
				};

				if (this.props.effectiveUserID) {
					params["effective_user_id"] = this.props.effectiveUserID;
				}

				CurrentUser.api().postStudentLists(params, $wr.apiHandler(function(response) {
					var classNumber = response["student_lists"].length;
					var title = "New " + $wr.pluralize("class", classNumber, "classes") + " added";
					var text = "You have successfully created " + classNumber + $wr.pluralize(" class", classNumber, " classes") + "!";

					this.props.addStudentLists(response["student_lists"]);

					window.wrNotifications.triggerDropDownNotification({
						title: title, text: text, icon: "ok-circle" }, 4000);

					this.setState({ loading: false })
				}.bind(this)));
			}
		} else {
			$("#addClassModal").find(".modalErrors").show();
		}
	}

	show() {
		this.refs.modal.show();
	}

	addClassRow() {
		this.setState({ classRows: this.state.classRows + 1 })
	}

	removeClassRow() {
		this.setState({ classRows: this.state.classRows - 1 })
	}

	componentDidMount() { 
		$("#addClassModal").keypress(function(e) {
			if ($(".first_name").val() != "") {
		  		$(".modalErrors").hide();
		  	}
		});
	}

	render() {
		var classRows = [];

		for (var i = 0; i < this.state.classRows; i++) {
			if (CurrentUser.isSchoolAdmin()) {
				var teacherEmail = (
					<div className="inputContainer">
						<input className="form-control" name="teacher_email[]" 
							ref={'teacher_email' + i } defaultValue={ "" } />
					</div>
				);
				var defaultGradeLevel = "";			
			} else {
				var defaultGradeLevel = parseInt(CurrentUser.get().grade_level);
			}
			classRows.push(
				<div id={"classRow" + i} key={ "classRow" + i }>
					<div className="inputContainer">
						<input className='email form-control' name='name[]' 
							type='text' ref={ 'name' + i } />
					</div>
					{ teacherEmail }
					<div className="inputContainer studentListDropDown gradeLevel">
						<select name="grade_level" ref={ "grade_level" + i } 
							className="form-control" defaultValue={ defaultGradeLevel }>
							{ DropDownOptions.Select.GradeLevels() }
						</select>
					</div>	
					<a href="#" className="clear" onClick={ this.removeClassRow } 
						style={{ display: this.state.classRows > 1 ? "inline-block" : "none" }}>
						<span className="glyphicon glyphicon-minus-sign">
						</span>
					</a>
				</div>
			)
		};

		var modalClassName = "studentRosterModal wideModal";

		if (CurrentUser.isSchoolAdmin()) {
			var emailHeader = (
				<p className="addClassColumnHeader inputContainer">Teacher Email 
					<span className="optionalField">(optional)</span>
				</p>
			);

			modalClassName += " withEmail";
		}

		var modalBody = (
			<div className="manualView">
				<form onSubmit={ this.submitClass } className="addNewClassForm">
					<p className="addClassColumnHeader inputContainer">Class Name</p>
					{ emailHeader }
					<p className="addClassColumnHeader inputContainer gradeLevel">Grade</p>
					{ classRows }
					<a href="#" id="addRow" className="btn-link" onClick={ this.addClassRow }>
						Add class
						<span className="glyphicon glyphicon-plus-sign"></span>
					</a>  
					<LoadingButton className="buttonSuccess center-block" text="Add Classes" loading={ this.state.loading } />
				</form>
			</div>
		);

		return (
			<div id="addClassModal">
				<Modal className={ modalClassName }
					headerText="Add Classes" ref="modal">
					<p className="modalErrors" style={{"display" : "none"}}>Please enter a class name.</p>
					{ modalBody }
				</Modal>
			</div>
		)
	}
};

AddNewClassModal.propTypes = StrictPropTypes({
	addStudentLists: PropTypes.func,
	studentLists: PropTypes.array,
	effectiveUserID: PropTypes.number,
});

module.exports = AddNewClassModal;


// WEBPACK FOOTER //
// ./modules/components/org/roster/AddNewClassModal.js